import React, { useState } from "react";
import {
    FacebookShareButton,
    FacebookMessengerShareButton,
    LinkedinShareButton,
    TelegramShareButton,
    TwitterShareButton,
    ViberShareButton,
    FacebookIcon,
    FacebookMessengerIcon,
    TelegramIcon,
    TwitterIcon,
    ViberIcon,
    LinkedinIcon,
} from "next-share";
import { getClientUrl } from "../../env";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import LinkRoundedIcon from '@mui/icons-material/LinkRounded'
import { Alert, Snackbar } from "@mui/material";

const Share = ({ id, title }) => {

    const [copied, setCopied] = useState(false);
    const url = getClientUrl() + 'item/' + id;
    return (
        <div>
            <FacebookShareButton url={url} quote={title}><FacebookIcon size={32} round /></FacebookShareButton>
            <FacebookMessengerShareButton url={url}><FacebookMessengerIcon size={32} round /></FacebookMessengerShareButton>
            <ViberShareButton url={url}><ViberIcon size={32} round /></ViberShareButton>
            <TelegramShareButton url={url} title={title}><TelegramIcon size={32} round /></TelegramShareButton>
            <TwitterShareButton url={url} title={title}><TwitterIcon size={32} round /></TwitterShareButton>
            <LinkedinShareButton url={url} title={title} source={getClientUrl()}><LinkedinIcon size={32} round /></LinkedinShareButton>
            <CopyToClipboard text={url}
                onCopy={() => setCopied(true)} style={{display:'inline-block', verticalAlign:'top', cursor:'pointer'}}>
                <div style={{ height: '100%', cursor: 'pointer', fontSize: '10px' }}><LinkRoundedIcon fontSize="large" style={{ verticalAlign: 'middle' }} /> <span style={{ verticalAlign: 'middle', textDecoration: 'underline', fontSize:'10px' }}>Сподели линк</span></div>
            </CopyToClipboard>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={copied}
                onClose={() => setCopied(false)}
            >
                <Alert onClose={() => setCopied(false)} severity="success" sx={{ width: '100%' }}>
                    Усшешно ископиран линк
                </Alert>
            </Snackbar>
        </div >
    )
}

export default Share;